<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                © {{year}} Health Exam™.
            </div>
        </div>
    </div>
</footer>